import type { FaireProductEntity } from "../../entity_types/product";

export const p_uxqntyedga: FaireProductEntity = {
  token: "p_uxqntyedga",
  type: "product",
  name: "WINTER FLIP FLOP - Cozy, Sherpa Flip Flop",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/2d856ad10f2e0df69699e036afd9461bfa5f6fe6948e85259c76392320ed1b57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/50afafc2c1546809f4addf5abfa632e3d3c9ed40348c94edbe38ecc5ca6af407.jpeg",
    "https://cdn.faire.com/fastly/4aaa92f3995f8ae4a770f07e5f09ad13bfd9e07223831d90e8898e11545320f8.jpeg",
    "https://cdn.faire.com/fastly/7a58d5a85e73de9767b748b71037b469e5c6c7948435b9018959bc985da5e72f.jpeg",
    "https://cdn.faire.com/fastly/cee62c13b42bc46d75e5026caa35fc04403001d09f50ce0e520b1b6985d692f0.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "The ultimate cold-weather flip flop, featuring a plush faux fur footbed paired with sleek thong straps for a cozy-meets-cool twist. Soft, fuzzy, and effortlessly easy to slip on, this style brings a playful seasonal update to an everyday silhouette. Available in sand, tan, chocolate, and burgundy.\n\nOOTD\nStyle them with baggy jeans, a fitted baby tee, and an oversized faux fur coat for a cozy off-duty look. Add a slouchy shoulder bag and chunky sunglasses to lean into the cool-girl winter vibe.",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T23:39:09.065Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
